import {
  GET_UNIQUE_LINK_LISTING_URL,
  GET_WITHDRAWAL_UNIQUE_LINK_LISTING_URL,
} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import {
  GET_UNIQUE_LINK_LISTING_QUERY_KEY,
  GET_WITHDRAWAL_UNIQUE_LINK_LISTING_QUERY_KEY,
} from '../../constants/queryKeys';
import { GenericExamLevel } from '../../api/candidate/exam/model';

interface Input {
  coordinatorUuid: string | undefined;
  examLevel: GenericExamLevel | undefined;
  onSuccess?: (res: UniqueLinkListingResponse) => void;
}

export interface UniqueLink {
  token: string;
  expiredDate: string;
  description: string;
  status: string;
}

interface UniqueLinkListingResponse {
  coordinatorName: string;
  model: UniqueLink[];
}

export const useGetUniqueLinkListing = ({ coordinatorUuid, examLevel, onSuccess }: Input) => {
  const getUniqueLinkListing = async () => {
    const res = await axiosClient.get<UniqueLinkListingResponse>(
      GET_UNIQUE_LINK_LISTING_URL(coordinatorUuid, examLevel)
    );
    return res.data;
  };

  return useCustomQuery(
    [GET_UNIQUE_LINK_LISTING_QUERY_KEY, coordinatorUuid, examLevel],
    getUniqueLinkListing,
    { enabled: !!coordinatorUuid && !!examLevel, onSuccess }
  );
};

export const useGetWithdrawalUniqueLinkListing = ({
  coordinatorUuid,
  examLevel,
  onSuccess,
}: Input) => {
  const getUniqueLinkListing = async () => {
    const res = await axiosClient.get<UniqueLinkListingResponse>(
      GET_WITHDRAWAL_UNIQUE_LINK_LISTING_URL(coordinatorUuid, examLevel)
    );
    return res.data;
  };

  return useCustomQuery(
    [GET_WITHDRAWAL_UNIQUE_LINK_LISTING_QUERY_KEY, coordinatorUuid, examLevel],
    getUniqueLinkListing,
    { enabled: !!coordinatorUuid && !!examLevel, onSuccess }
  );
};
